import styled from 'styled-components';
import { Col as Col_, Row as Row_ } from 'reactstrap';
import { getTheme, ifProp, size } from 'mol-ui';

export const CalendarContainer = styled.div`
    padding: 2px;
`;

export const Container = styled.div`
    align-items: center;
    border: 1px solid ${ getTheme('primaryColor') };
    border-radius: 4px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    max-height: 380px;
    min-height: 380px;
    min-width: 358px;
    max-width: 358px;
    padding: 20px 0px;
`;

export const Col = styled(Col_)`
    margin: 0px;
    padding: 0px;
    text-align: center;
`;

export const DayCell = styled(Col_).withConfig({
    shouldForwardProp: prop => !['highlighted'].includes(prop)
})`
    align-items: center;
    cursor: pointer;
    display: flex;
    font-size: 14px;
    height: calc(200px/${ ({ lines }) => lines ? lines : 6 });
    justify-content: center;
    min-width: 50px;
    max-width: 50px;
    ${ ifProp('outofrange', 'opacity: 0.2;', '') };
    padding: 0px;

    ${ ({ highlighted, theme: { primaryColor } }) => !highlighted ? '' : `
        background: ${ primaryColor };
        border-radius: 45px;
        color: white;
        font-weight: 500;
        transition: all 300ms ease;

        :hover {
            background-color: white;
            box-shadow: 0px 0px 5px rgba(0,0,0,0.5) inset;
            color: ${ primaryColor };
        }
    ` }
`;

export const DayRow = styled(Row_)`
    margin: 0px;
`;

export const HeaderCell = styled(Col_)`
    align-items: center;
    display: flex;
    font-size: 13px;
    height: 40px;
    justify-content: center;
    min-width: 50px;
    max-width: 50px;
    padding: 0px;
`;

export const HeaderRow = styled(Row_)`
    margin: 0px;
`;

export const LoaderContainer = styled.div `
    height: 257px;
    padding: 20px;
`;

export const Row = styled(Row_)`
    align-items: center;
    display: flex;
    justify-content: center;
    margin: 10px 0px;
    width: 100%;
`;
